// extracted by mini-css-extract-plugin
module.exports = {"criteria":"VenueCriteria-module--criteria--82144e","name":"VenueCriteria-module--name--228fc0","criteriaCol":"VenueCriteria-module--criteriaCol--60cf9a"};